import React, { createContext, useContext, useState } from 'react';

import { IBaseProps, IBringgUuids } from '@rbi-ctg/frontend';
import { useMemoAll } from 'utils/use-memo-all';

interface IDeliveryConfirmationContext {
  bringgUuids: IBringgUuids;
  setBringgUuids: (bringgUuids: IBringgUuids) => void;
}

export const DeliveryConfirmationContext = createContext<IDeliveryConfirmationContext>(
  {} as IDeliveryConfirmationContext
);

export const useDeliveryConfirmationContext = () => useContext(DeliveryConfirmationContext);

export const DeliveryConfirmationProvider = ({ children }: IBaseProps) => {
  const [bringgUuids, setBringgUuids] = useState<IBringgUuids>({});

  const value = useMemoAll({ bringgUuids, setBringgUuids });

  return (
    <DeliveryConfirmationContext.Provider value={value}>
      {children}
    </DeliveryConfirmationContext.Provider>
  );
};

export default DeliveryConfirmationContext.Consumer;
